import { T } from "@/components/i18n";

export function UploadInstructions({ text }: { text?: string }) {
  return (
    <div>
      {text && <p className="mb-4 text-sm text-neutral-600 dark:text-neutral-400">{text}</p>}
      <p>
        <T i18nKey="components.submission.uploadInstructions.body" />
      </p>
    </div>
  );
}
